export const SETTING_TAB_CLASSES = {
  medium: {
    root: 'px-12 h-40 rounded-8',
    container: 'space-s-8',
    icon: 'w-16 h-16 flex-shrink-0',
    label: 'body-short-02' as const,
    checkmarkIcon: 'w-20 h-20',
    circleIcon: 'w-16 h-16',
  },
  large: {
    root: 'px-16 h-48 rounded',
    container: 'space-s-12',
    icon: 'w-20 h-20 flex-shrink-0',
    label: 'body-short-01' as const,
    checkmarkIcon: 'w-24 h-24',
    circleIcon: 'w-20 h-20',
  },
  'x-large': {
    root: 'px-16 h-56 rounded',
    container: 'space-s-12',
    icon: 'w-20 h-20 flex-shrink-0',
    label: 'body-short-01' as const,
    checkmarkIcon: 'w-28 h-28',
    circleIcon: 'w-24 h-24',
  },
  'xx-large': {
    root: 'p-20 rounded',
    container: 'space-s-12 me-48',
    icon: 'w-20 h-20 flex-shrink-0',
    label: 'label-01' as const,
    checkmarkIcon: 'w-28 h-28 flex-shrink-0',
    circleIcon: 'w-24 h-24 flex-shrink-0',
  },
};
